
import { Slot } from "@radix-ui/react-slot"

import { cva } from "class-variance-authority"

import { cn } from "../lib/utils"

const buttonVariants = cva(

  "flex items-center justify-center whitespace-nowrap rounded-full font-bold transition-all cursor-pointer outline-none focus-visible:ring-[3px]",

  {

    variants: {

      variant: {

        primary: "text-white bg-blue-primary hover:bg-blue-primary-hover focus-visible:ring-blue-fresh",

        secondary: "text-blue-primary bg-green-bitter-lemon hover:bg-green-rio focus-visible:ring-green-light",

        ghost: "text-white hover:bg-blue-primary/50",

      },

      size: {

        small: "h-11 px-6 text-sm",

        primary: "h-12 px-8 text-base",

        large: "h-12 sm:h-14 px-8 sm:px-10 text-base sm:text-xl",

        icon: "size-7",

      },

    },

    defaultVariants: {

      variant: "primary",

      size: "primary",

    },

  }

)

function Button( { className, variant, size, asChild = false, ...props } ) {

  const Comp = asChild ? Slot : "button"

  return (

    <Comp

      className={ cn( buttonVariants( { variant, size, className } ) ) }

      {...props}

    />

  )

}

export { Button }
